import { firebase, dbFirestore } from "../../firebase";
import { clean, format } from "./CheckoutUtils";

export const Push = async (payload: ICheckoutPage) => {
    try {
        const docRef = dbFirestore
            .collection('checkout')
            .doc(payload.publicId);
        const cleanned = clean(payload);
        if (cleanned !== undefined) await docRef.set(cleanned);
    } catch (error) {
        console.error(error);
    }
};

export const SubscribeToGetAll = (
    onUpdate: (payload: ICheckoutPage[]) => void
): (() => void) => {
    try {
        let unsubscribe = dbFirestore
            .collection('checkout')
            .onSnapshot(docsSnapshot => {
                if (docsSnapshot.empty) onUpdate([]);
                else {
                    const arr: ICheckoutPage[] = [];

                    docsSnapshot.forEach(docSnapshot => {
                        const doc = docSnapshot.data();
                        const formatted = format(doc);
                        if (formatted !== undefined) arr.push(formatted);
                    });

                    arr.sort((a, b) => {
                        if (a.publicId < b.publicId) return -1;
                        if (a.publicId > b.publicId) return 1;
                        return 0;
                    });

                    onUpdate(arr);
                }
            });

        return () => unsubscribe();
    } catch (error) {
        console.error(error);
        return () => { };
    }
};

export const Delete = async (publicId: string) => {
    try {
        await dbFirestore
            .collection("checkout")
            .doc(publicId)
            .delete();
    } catch (error) {
        console.error(error);
    }
}

export const Update = async (payload: ICheckoutPage) => {
    try {
        const docRef = dbFirestore
            .collection('checkout')
            .doc(payload.publicId);

        const cleanned = clean(payload);
        if (cleanned !== undefined) await docRef.set(cleanned);
    } catch (error) {
        console.error(error);
    }
}

export const SubscribeToCheckoutPage = (
    publicId: string,
    onUpdate: (payload: ICheckoutPage | 'NO_EXIST') => void
): (() => void) => {
    try {
        let unsubscribe = dbFirestore
            .collection('checkout')
            .doc(publicId)
            .onSnapshot(docSnapshot => {
                if(docSnapshot.exists === false) onUpdate('NO_EXIST');
                const doc = docSnapshot.data();
                const formatted = format(doc);
                if (formatted !== undefined) onUpdate(formatted);
                else onUpdate('NO_EXIST');
            });

        return () => unsubscribe();
    } catch (error) {
        console.error(error);
        return () => { };
    }
}